import React, {useEffect, useState} from 'react';
import styled from "styled-components";
import Button from '@mui/material/Button';
import WeightGraph from "../WeightGraph";
import DragabbleBacklessModal from "../dialogs/DragabbleBacklessModal";

const WrapperStyled = styled.div`
    position: relative;
    height: 70%;
`;


const WeightDragableDialog = ({open, handleClose, weight}) => {

    const [formatedData, s_formatedData] = useState([]);

    useEffect(() => {
        if (weight) {
            const copy = [...formatedData];
            copy.push({
                time: Date.now(),
                deltaWeight: weight
            });
            s_formatedData(copy);
        }
    }, [weight]);

    useEffect(() => {
        s_formatedData([]);
    }, [open]);

    const handleCloseEvent = (e, reason) => {
        if (reason !== 'backdropClick') {
            handleClose();
        }
    };

    const dataIsPresent = !!formatedData?.length;

    return (
        <DragabbleBacklessModal>
            <WrapperStyled>
                {dataIsPresent && (
                    <WeightGraph
                        data={formatedData}
                    />
                )}
                {!dataIsPresent && (
                    <p>No data</p>
                )}
            </WrapperStyled>
            <div className="dra-actions">
                <Button autoFocus onClick={handleCloseEvent}>
                    Close
                </Button>
            </div>
        </DragabbleBacklessModal>
    );
};

export default WeightDragableDialog;